const geocodeErrors = {
  NO_RESULTS: 'No Results Found',
  UNABLE_TO_GEOCODE: 'Unable To Geocode',
  INVALID_COORDINATES: 'Invalid Coordinates',
  MAP_NOT_INITIALISED: 'Map Not Initialised',
};

export default geocodeErrors;
